export default {
  title: "Algorithmen",
  pageTitle: "Kursdetails",
  parentTitle: "Kurse",
};
